//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customerDiscGrpProd', {
//        templateUrl: 'views/components/views/customerDiscGrpProd/customerDiscGrpProd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'customerDiscGrpProdService', function ($stateParams, customerDiscGrpProdService) {
//            const vm = this;
//            let custNo = $stateParams.cust_no;

//            vm.model = {
//                inputListCustomerDiscounts: []
//            };

//            async function loadCustomerDiscounts() {
//                vm.model.inputListCustomerDiscounts = await customerDiscGrpProdService.listCustomerDiscounts({ cust_no: custNo });
//            }

//            vm.$onInit = function () {
//                loadCustomerDiscounts();
//            }
//        }]
//    });
//})();
